export type SearchParamsType = {
  filter: {
    search: string;
    status: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  purposeId: number;
  clinicId: number;
  createdById: number;
  createdDate: string;
  purposeCode: string;
  purposeName: string;
  purposeStatus: number;
  isConsulted: number;
};

export type MasterDataType = {
  purposeId: number | null;
  purposeCode: string;
  purposeName: string;
  purposeStatus: number;
  clinicId: number;
  createdById: number;
  createdDate: string;
  isConsulted: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  purposeCode: string;
  purposeName: string;
  purposeStatus: number;
  isConsulted: number;
};

export const initialFormData: MasterFormDataType = {
  purposeCode: "",
  purposeName: "",
  purposeStatus: 1,
  isConsulted: 0,
};
